module.exports = new __parcel__URL__("cornershop-design-principles.9a2eab89.webp").toString();